import { render, staticRenderFns } from "./LeadSummary.vue?vue&type=template&id=45140dce&scoped=true"
import script from "./LeadSummary.vue?vue&type=script&lang=js"
export * from "./LeadSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45140dce",
  null
  
)

export default component.exports